import { render } from "./Features.vue?vue&type=template&id=f822699a"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import "@/styles/components/_feature.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script